import { memo } from "react";

import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

type Props = {
	title: string;
	contents: SearchedContent;
};

export const Category = memo(({ title, contents }: Props) => {
	return (
		<div className="ml-3 w-full">
			<ol className="">
				<li>
					<a
						className="text-chillnn-base hover:decoration-chillnn-base whitespace-nowrap border-b border-transparent text-lg font-bold hover:underline hover:underline-offset-2"
						href={`#${title}`}
					>
						<h4 className="p-1 font-bold">{title}向け</h4>
					</a>
				</li>
				<li className="ml-2">
					{contents.map((content, idx) => (
						<a href={`#${title}-${content.categoryKey}`} key={`${content.categoryKey}-${idx}`}>
							<h5 className="text-chillnn-base hover:decoration-chillnn-base whitespace-nowrap border-b border-transparent px-2 py-1 text-base hover:underline hover:underline-offset-2">
								{content.categoryName}
							</h5>
						</a>
					))}
				</li>
			</ol>
		</div>
	);
});
